import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { gsap } from 'gsap';

const EmpaticaDescription = () => {
  const history = useHistory();
  const containerRef = useRef(null);
  const titleRef = useRef(null);
  const contentRefs = useRef([]);
  const buttonRef = useRef(null);

  // Animación de entrada
  useEffect(() => {
    const elements = [
      titleRef.current,
      ...contentRefs.current,
      buttonRef.current
    ].filter(Boolean);

    // Resetear opacidad inicial
    gsap.set(elements, { opacity: 0, y: 20 });

    // Animación secuencial
    gsap.to(containerRef.current, { opacity: 1, duration: 0.5 });
    
    const tl = gsap.timeline({ defaults: { ease: "power2.out" } });
    tl.to(titleRef.current, { 
      opacity: 1, 
      y: 0, 
      duration: 0.8 
    })
    .to(contentRefs.current, { 
      opacity: 1, 
      y: 0, 
      duration: 0.6, 
      stagger: 0.15 
    }, "-=0.4")
    .to(buttonRef.current, { 
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "elastic.out(1, 0.5)"
    }, "-=0.3");

    // Animación flotante continua para el botón
    gsap.to(buttonRef.current, {
      y: -10,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      delay: 1.5
    });
  }, []);

  const handleGoBack = () => {
    const elements = [
      titleRef.current,
      ...contentRefs.current,
      buttonRef.current
    ].filter(Boolean);

    // Animación de salida
    gsap.to(elements, {
      opacity: 0,
      y: -20,
      duration: 0.5,
      stagger: 0.1,
      onComplete: () => history.push('/empaticapage')
    });
  };

  const addToRefs = (el) => {
    if (el && !contentRefs.current.includes(el)) {
      contentRefs.current.push(el);
    }
  };

  return (
    <div 
      ref={containerRef}
      style={{
        backgroundImage: 'url("/Info_Fondo.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight: '100vh',
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        color: '#333',
        opacity: 0,
        position: 'relative',
      
      }}
    >
      <h1 
        ref={titleRef}
        style={{
          fontSize: '60px',
          fontWeight: 'bold',
          opacity: 0,
          color: '#0f4c75',
          marginTop: '0px',
        }}
      >
        Empática:
      </h1>
      
      <h2 
        ref={addToRefs}
        style={{
          fontSize: '50px',
          fontWeight: 'normal',
          marginBottom: '30px',
          opacity: 0,
          color: '#0f4c75',
          lineHeight: '90%',
        }}
      >
        Soluciones que conectan 
        <h2>tecnología con personas</h2>
      </h2>
      
      <p 
        ref={addToRefs}
        style={{
          fontSize: '20px',
          lineHeight: '1.2',
          marginBottom: '20px',
          maxWidth: '800px',
          opacity: 0
        }}
      >
        En <strong style={{ color: 'black', fontWeight: 'bold' }}>Empática</strong> creamos <strong style={{ color: 'black', fontWeight: 'bold' }}>tecnología que entiende a las personas</strong>.
        <p>Desarrollamos herramientas y procesos que hacen más fácil el día a día en tres frentes clave:</p>
        <strong>negocios privados, sector público y organizaciones.</strong>
      </p>
      
      <p 
        ref={addToRefs}
        style={{
          fontSize: '20px',
          lineHeight: '1.2',
          marginBottom: '20px',
          maxWidth: '800px',
          opacity: 0
        }}
      >
        Desde cajeros inteligentes y puntos de venta, hasta sistemas de gestión para organismos públicos y programas de consultoría para fortalecer equipos, en Empática 
        <strong> transformamos necesidades en soluciones concretas, asequibles y empáticas.</strong> 
      </p>
      
      <p 
        ref={addToRefs}
        style={{
          fontSize: '20px',
          lineHeight: '1.2',
          marginBottom: '20px',
          maxWidth: '800px',
          opacity: 0
        }}
      >
        Nos mueve la innovación con propósito, el trabajo bien hecho y la convicción de que el verdadero progreso se construye con las personas al centro.
      </p>

      <button 
        ref={buttonRef}
        onClick={handleGoBack}
        style={{
           
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: 'rgba(15, 76, 117, 0.8)',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            left: '50%',
            bottom: window.innerWidth <= 768 ? '0px' : '30px',
            transform: 'translateX(-50%)',
            opacity: 0,
            outline: 'none',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            transition: 'all 0.3s ease',
            ':hover': {
              backgroundColor: 'rgba(50, 130, 184, 0.8)',
              transform: 'translateX(-50%) scale(1.1)'
          }
        }}
        aria-label="Volver al inicio"
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M7 15L12 10L17 15" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default EmpaticaDescription;